import { useEffect, useState } from "react";
import Breadcrumb from "../../../components/partials/Breadcrumb";
import { BiCategory } from "react-icons/bi";
import { Formik } from "formik";
import * as Yup from "yup";
import { Alerts, GetSettings } from "../../../helpers";
import Card from 'react-bootstrap/Card';
import parse from 'html-react-parser';
import { FaEdit, FaTimes } from "react-icons/fa";
import ConfModal from "../../../components/cmp/ConfModal";
import ThemeModal from "../../../components/cmp/ThemeModal";
const breadcrumbs = [
    { id: 1, label: "Dashboard", link: "/" },
    { id: 2, label: "Categories", link: "/app/post/categories" },
    { id: 3, label: "Create New", link: "/app/post/categories/create" },
];

const ShippingZoneRates = () => {
    const [isLoading, setLoading] = useState(true);
    const [shippingZoneRates, setShippingZoneRates] = useState([]);
    const [showConditional, setShowConditional] = useState(false);
    const [shippingRateLabels, setShippingRateLabels] = useState([]);
    const [shippingData, setSingleRate] = useState(null);
    const [isEdit, setEdit] = useState(false);

    const handleOpenEdit = (item) => {
        console.log(item)
        setSingleRate(item);
        setEdit(true)
    }
    const handleCloseEdit = (item) => {
        setSingleRate(null);
        setEdit(false)
    }



    const getShippingZoneRates = async () => {
        const resp = await GetSettings.getAllShippingZoneRates();
        if (resp && resp.status) {
            setShippingZoneRates(resp.shipping_rates);
            setLoading(false);
        }
    }

    const validationSchema = Yup.object({
        rateType: Yup.string().required("Required"),
        shipping_rate_label_id: Yup.string().required("Required"),
        price: Yup.number().min(0, "Price cannot be negative").required("Required"),
        conditionalType: Yup.string().when([], {
            is: () => showConditional,
            then: (schema) => schema.required("Required"),
        }),
        minWeight: Yup.number().when("conditionalType", {
            is: "weight",
            then: (schema) => schema.required("Required").min(0, "Must be >= 0"),
        }),
        maxWeight: Yup.number().when("conditionalType", {
            is: "weight",
            then: (schema) => schema.required("Required"),
        }),
        minPrice: Yup.number().when("conditionalType", {
            is: "price",
            then: (schema) => schema.required("Required").min(0, "Must be >= 0"),
        }),
        maxPrice: Yup.number().when("conditionalType", {
            is: "price",
            then: (schema) => schema.required("Required"),
        }),
    });

    const getShippingRateLabels = async () => {
        const resp = await GetSettings.getShippingRateLabels();
        if (resp && resp.status) {
            setShippingRateLabels(resp.shipping_rate_labels);
            setLoading(false);
        }
    };

    useEffect(() => {
        getShippingRateLabels();
        getShippingZoneRates();
           if (
      shippingData?.shipping_rate_type ||
      shippingData?.min_weight > 0 ||
      shippingData?.max_weight > 0 ||
      shippingData?.min_price > 0 ||
      shippingData?.max_price > 0
    ) {
      setShowConditional(true);
    }
    }, [shippingData]);


    const handleAddShippingZoneRate = async (values, { setSubmitting, resetForm }) => {
        const resp = await GetSettings.createShippingZoneRate(values);
        if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-center', 'success');
            setSubmitting(false);
            resetForm();
            getShippingZoneRates();
            setShowConditional(false);
        } else {
            Alerts.alertMessage('Something went wrong!', 'top-center', 'error');
            setSubmitting(false);
        }
    }


    const handleUpdateShippingZoneRate = async (values, { setSubmitting, resetForm }) => {
        const resp = await GetSettings.updateShippingZoneRate(shippingData.id, values);
        if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-center', 'success');
            setSubmitting(false);
            getShippingZoneRates();
            handleCloseEdit();
        } else {
            Alerts.alertMessage('Something went wrong!', 'top-center', 'error');
            setSubmitting(false);
        }
    }

    const handleDeleteRate = async (delId) => {
        const resp = await GetSettings.deleteShippingZoneRates(delId);
        if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-center', 'success');
            getShippingZoneRates();
        } else {
            Alerts.alertMessage('Something went wrong!', 'top-center', 'error');
        }
    }


    return (
        <>
            <Breadcrumb breadcrumbs={breadcrumbs} />
            <div className="innerPageWrapper">
                <div className="container-fluid">
                    <div className="page-title">
                        <h2>
                            <BiCategory /> Shipping Zone Rates
                        </h2>

                    </div>
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <Card style={{ width: '100%' }}>
                                        <Card.Header><h5> Add New</h5></Card.Header>
                                        <Card.Body>
                                            <Formik
                                                enableReinitialize={true}
                                                initialValues={{
                                                    rateType: "flat_rate",
                                                    shipping_rate_label_id: shippingRateLabels.length > 0 ? shippingRateLabels[0].id : '',
                                                    shippingRateLabel: shippingRateLabels.length > 0 ? shippingRateLabels[0].preview_label : '',
                                                    price: 0,
                                                    currency: "GBP",
                                                    conditionalType: "",
                                                    minWeight: 0.00,
                                                    maxWeight: 0.00,
                                                    minPrice: 0.00,
                                                    maxPrice: 0.00
                                                }}
                                                validationSchema={validationSchema}
                                                onSubmit={handleAddShippingZoneRate}
                                            >
                                                {({
                                                    values,
                                                    errors,
                                                    touched,
                                                    handleChange,
                                                    handleBlur,
                                                    handleSubmit,
                                                    setFieldValue,
                                                    isSubmitting
                                                }) => (
                                                    <form onSubmit={handleSubmit}>
                                                        {/* Rate Type */}
                                                        <div className="mb-3">
                                                            <label>Rate type</label>
                                                            <select
                                                                name="rateType"
                                                                value={values.rateType}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                className="form-control"
                                                            >
                                                                <option value="flat_rate">Use flat rate</option>
                                                                {/* <option value="calculated_rate">Use calculated rate</option> */}
                                                            </select>
                                                            {touched.rateType && errors.rateType && (
                                                                <div className="text-red-500 text-sm">{errors.rateType}</div>
                                                            )}
                                                        </div>

                                                        {/* Shipping Rate */}
                                                        <div className="mb-3">
                                                            <label>Shipping rate</label>
                                                            <select
                                                                name="shipping_rate_label_id"
                                                                value={values.shipping_rate_label_id}
                                                                onChange={(e) => {
                                                                    handleChange(e);
                                                                    let fLabel = shippingRateLabels.find(el => el.id === parseInt(e.target.value))
                                                                    if (fLabel) {
                                                                        setFieldValue('shippingRateLabel', fLabel.preview_label)
                                                                    }
                                                                }}
                                                                onBlur={handleBlur}
                                                                className="form-control"
                                                            >
                                                                {shippingRateLabels.length > 0 &&
                                                                    shippingRateLabels.map((labelItem) => (
                                                                        <option value={labelItem.id} key={labelItem.id}>
                                                                            {labelItem.name}
                                                                        </option>
                                                                    ))}
                                                            </select>
                                                            {touched.shippingRate && errors.shippingRate && (
                                                                <div className="text-red-500 text-sm">
                                                                    {errors.shippingRate}
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Price */}
                                                        <div className="row">
                                                            <div className="mb-3 col-md-6 price-input">
                                                                <label>Price</label>
                                                                <input
                                                                    type="number"
                                                                    name="price"
                                                                    value={values.price}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    className="form-control hid-icon"
                                                                    placeholder="0.00"
                                                                />
                                                                {values.price === 0 || values.price === '' && <span>Free</span>}
                                                            </div>
                                                            <div className="mb-3 col-md-6">
                                                                <label>&nbsp;</label>
                                                                <select
                                                                    name="currency"
                                                                    value={values.currency}
                                                                    onChange={handleChange}
                                                                    className="form-control"
                                                                >
                                                                    <option value="GBP">British Pound (GBP £)</option>
                                                                    {/* <option value="USD">US Dollar ($)</option>
                    <option value="EUR">Euro (€)</option> */}
                                                                </select>
                                                                {touched.price && errors.price && (
                                                                    <div className="text-red-500 text-sm">{errors.price}</div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {/* Conditional Pricing Toggle */}
                                                        <div className={showConditional ? "mb-1" : "mb-3"}>
                                                            <label
                                                                className="block font-medium text-primary"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => {
                                                                    setShowConditional(!showConditional)
                                                                    setFieldValue('minWeight', '')
                                                                    setFieldValue('maxWeight', '')
                                                                    setFieldValue('minPrice', '')
                                                                    setFieldValue('maxPrice', '')
                                                                    setFieldValue('conditionalType', '')

                                                                }
                                                                }
                                                            >
                                                                {showConditional
                                                                    ? "Remove Conditional Pricing"
                                                                    : "Add Conditional Pricing"}
                                                            </label>
                                                        </div>

                                                        {/* Conditional Section */}
                                                        {showConditional && (
                                                            <>
                                                                {/* Radio Buttons */}
                                                                <div className="mb-3">
                                                                    <label className="d-flex align-items-center gap-2">
                                                                        <input
                                                                            type="radio"
                                                                            name="conditionalType"
                                                                            value="weight"
                                                                            checked={values.conditionalType === "weight"}
                                                                            onChange={(e) => {
                                                                                handleChange(e);
                                                                                setFieldValue('minWeight', '')
                                                                                setFieldValue('maxWeight', '')
                                                                                setFieldValue('minPrice', '')
                                                                                setFieldValue('maxPrice', '')
                                                                            }}
                                                                        />
                                                                        Based on item weight
                                                                    </label>
                                                                    <label className="d-flex align-items-center gap-2">
                                                                        <input
                                                                            type="radio"
                                                                            name="conditionalType"
                                                                            value="price"
                                                                            checked={values.conditionalType === "price"}
                                                                            onChange={(e) => {
                                                                                handleChange(e);
                                                                                setFieldValue('minWeight', '')
                                                                                setFieldValue('maxWeight', '')
                                                                                setFieldValue('minPrice', '')
                                                                                setFieldValue('maxPrice', '')
                                                                            }}
                                                                        />
                                                                        Based on order price

                                                                    </label>
                                                                    {touched.conditionalType && errors.conditionalType && (
                                                                        <div className="text-red-500 text-sm">
                                                                            {errors.conditionalType}
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                {/* Min & Max Weight */}
                                                                {values.conditionalType === "weight" && (
                                                                    <div className="row">
                                                                        <div className="col-md-6 mb-3">
                                                                            <label>Minimum weight (kg)</label>
                                                                            <input
                                                                                type="number"
                                                                                name="minWeight"
                                                                                value={values.minWeight}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                className="form-control"
                                                                            />
                                                                            {touched.minWeight && errors.minWeight && (
                                                                                <div className="text-red-500 text-sm">
                                                                                    {errors.minWeight}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                        <div className="col-md-6 mb-3">
                                                                            <label>Maximum weight (kg)</label>
                                                                            <input
                                                                                type="number"
                                                                                name="maxWeight"
                                                                                value={values.maxWeight}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                className="form-control"
                                                                            />
                                                                            {touched.maxWeight && errors.maxWeight && (
                                                                                <div className="text-red-500 text-sm">
                                                                                    {errors.maxWeight}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {/* Min & Max Price */}
                                                                {values.conditionalType === "price" && (
                                                                    <div className="row">
                                                                        <div className="col-md-6 mb-3">
                                                                            <label>Minimum price (£)</label>
                                                                            <input
                                                                                type="number"
                                                                                name="minPrice"
                                                                                value={values.minPrice}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                className="form-control"
                                                                            />
                                                                            {touched.minPrice && errors.minPrice && (
                                                                                <div className="text-red-500 text-sm">
                                                                                    {errors.minPrice}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                        <div className="col-md-6 mb-3">
                                                                            <label>Maximum price (£)</label>
                                                                            <input
                                                                                type="number"
                                                                                name="maxPrice"
                                                                                value={values.maxPrice}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                className="form-control"
                                                                            />
                                                                            {touched.maxPrice && errors.maxPrice && (
                                                                                <div className="text-red-500 text-sm">
                                                                                    {errors.maxPrice}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}

                                                        {/* Preview */}
                                                        <div className=" preview-box">
                                                            <p>
                                                                <strong>Checkout preview</strong>
                                                            </p>
                                                            <div className="preview-box-inner border rounded bg-gray-100">
                                                                <div>
                                                                    <div className="check-icon">
                                                                        <img src="/images/radio-icon.png" alt="" />
                                                                    </div>
                                                                    <div>{parse(values.shippingRateLabel)}</div>
                                                                    {values.conditionalType === "price" ? `Price Range - (£${values.minPrice} - £${values.maxPrice})` : null}
                                                                    {values.conditionalType === "weight" ? `Weight Range - (${values.minWeight}kg - ${values.maxWeight}kg)` : null}
                                                                </div>
                                                                <div className="price-tag">{values.price > 0 ? `£ ${values.price}` : 'Free'}</div>
                                                            </div>

                                                        </div>

                                                        {/* Submit */}
                                                        <div className="mt-3">
                                                            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                                                {isSubmitting ? 'Please wait..' : 'Add Now'}
                                                            </button>
                                                        </div>
                                                    </form>
                                                )}
                                            </Formik>
                                        </Card.Body>
                                    </Card>

                                </div>
                                <div className="col-md-6">
                                    <Card style={{ width: '100%' }}>
                                        <Card.Header><h5>Shipping Zone Rates</h5></Card.Header>
                                        <Card.Body>
                                            {
                                                shippingZoneRates && shippingZoneRates.length > 0 ? (
                                                    <>
                                                        {shippingZoneRates.map((zone_rate) => {


                                                            return (
                                                                <div
                                                                    key={zone_rate.id}
                                                                    className={`preview-box-inner border rounded bg-gray-100`}
                                                                    style={{ padding: "15px" }}
                                                                >

                                                                    <div className="d-flex justify-content-between align-items-center">

                                                                        <div>
                                                                            <div>{parse(zone_rate.shipping_rate_label.preview_label)}</div>
                                                                            {zone_rate.shipping_rate_type === "price"
                                                                                ? `Price Range - (£${zone_rate.min_price} - £${zone_rate.max_price})`
                                                                                : null}
                                                                            {zone_rate.shipping_rate_type === "weight"
                                                                                ? `Weight Range - (${zone_rate.min_weight}kg - ${zone_rate.max_weight}kg)`
                                                                                : null}
                                                                        </div>

                                                                    </div>

                                                                    <div className="price-tag">
                                                                        {parseFloat(zone_rate.price) > 0 ? (
                                                                            <div className="shipping-price">£ {zone_rate.price}</div>
                                                                        ) : (
                                                                            <span>Free</span>
                                                                        )}
                                                                        <div className="actions mt-3">
                                                                            <button className="btn btn-info btn-sm" onClick={() => handleOpenEdit(zone_rate)}><FaEdit /></button>
                                                                            <ConfModal message={'Are you sure you want to delete this rate? This action will remove it from all associated shipping zones.'} delId={zone_rate.id} handleDelete={handleDeleteRate} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </>
                                                ) : (
                                                    <p className="rate-not-found">Rate not added !</p>
                                                )
                                            }

                                        </Card.Body>
                                    </Card>
                                    {shippingData && <ThemeModal show={isEdit} handleHide={handleCloseEdit} title={'Update Shipping Zone Rate'} >
                                        <Formik
                                            enableReinitialize={true}
                                            initialValues={{
                                                rateType: shippingData?.rate_type || "flat_rate",
                                                shipping_rate_label_id:
                                                    shippingData?.shipping_rate_label_id ||
                                                    (shippingRateLabels.length > 0 ? shippingRateLabels[0].id : ""),
                                                shippingRateLabel:
                                                    shippingData?.shipping_rate_label?.preview_label ||
                                                    (shippingRateLabels.length > 0 ? shippingRateLabels[0].preview_label : ""),
                                                price: shippingData?.price || 0,
                                                currency: shippingData?.currency || "GBP",
                                                conditionalType: shippingData?.shipping_rate_type || "",
                                                minWeight: shippingData?.min_weight || "",
                                                maxWeight: shippingData?.max_weight || "",
                                                minPrice: shippingData?.min_price || "",
                                                maxPrice: shippingData?.max_price || "",
                                            }}
                                            validationSchema={validationSchema}
                                            onSubmit={handleUpdateShippingZoneRate}
                                        >
                                            {({
                                                values,
                                                errors,
                                                touched,
                                                handleChange,
                                                handleBlur,
                                                handleSubmit,
                                                setFieldValue,
                                                isSubmitting
                                            }) => (
                                                <form onSubmit={handleSubmit}>
                                                    {/* Rate Type */}
                                                    <div className="mb-3">
                                                        <label>Rate type</label>
                                                        <select
                                                            name="rateType"
                                                            value={values.rateType}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            className="form-control"
                                                        >
                                                            <option value="flat_rate">Use flat rate</option>
                                                            {/* <option value="calculated_rate">Use calculated rate</option> */}
                                                        </select>
                                                        {touched.rateType && errors.rateType && (
                                                            <div className="text-red-500 text-sm">{errors.rateType}</div>
                                                        )}
                                                    </div>

                                                    {/* Shipping Rate */}
                                                    <div className="mb-3">
                                                        <label>Shipping rate</label>
                                                        <select
                                                            name="shipping_rate_label_id"
                                                            value={values.shipping_rate_label_id}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                                let fLabel = shippingRateLabels.find(el => el.id === parseInt(e.target.value))
                                                                if (fLabel) {
                                                                    setFieldValue('shippingRateLabel', fLabel.preview_label)
                                                                }
                                                            }}
                                                            onBlur={handleBlur}
                                                            className="form-control"
                                                        >
                                                            {shippingRateLabels.length > 0 &&
                                                                shippingRateLabels.map((labelItem) => (
                                                                    <option value={labelItem.id} key={labelItem.id}>
                                                                        {labelItem.name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                        {touched.shippingRate && errors.shippingRate && (
                                                            <div className="text-red-500 text-sm">
                                                                {errors.shippingRate}
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Price */}
                                                    <div className="row">
                                                        <div className="mb-3 col-md-6 price-input">
                                                            <label>Price</label>
                                                            <input
                                                                type="number"
                                                                name="price"
                                                                value={values.price}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                className="form-control hid-icon"
                                                                placeholder="0.00"
                                                            />
                                                            {values.price === 0 || values.price === '' && <span>Free</span>}
                                                        </div>
                                                        <div className="mb-3 col-md-6">
                                                            <label>&nbsp;</label>
                                                            <select
                                                                name="currency"
                                                                value={values.currency}
                                                                onChange={handleChange}
                                                                className="form-control"
                                                            >
                                                                <option value="GBP">British Pound (GBP £)</option>
                                                                {/* <option value="USD">US Dollar ($)</option>
                                                                 <option value="EUR">Euro (€)</option> */}
                                                            </select>
                                                            {touched.price && errors.price && (
                                                                <div className="text-red-500 text-sm">{errors.price}</div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Conditional Pricing Toggle */}
                                                    <div className={showConditional ? "mb-1" : "mb-3"}>
                                                        <label
                                                            className="block font-medium text-primary"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => {
                                                                setShowConditional(!showConditional)
                                                                setFieldValue('minWeight', '')
                                                                setFieldValue('maxWeight', '')
                                                                setFieldValue('minPrice', '')
                                                                setFieldValue('maxPrice', '')
                                                                setFieldValue('conditionalType', '')

                                                            }
                                                            }
                                                        >
                                                            {showConditional
                                                                ? "Remove Conditional Pricing"
                                                                : "Add Conditional Pricing"}
                                                        </label>
                                                    </div>

                                                    {/* Conditional Section */}
                                                    {showConditional && (
                                                        <>
                                                            {/* Radio Buttons */}
                                                            <div className="mb-3">
                                                                <label className="d-flex align-items-center gap-2">
                                                                    <input
                                                                        type="radio"
                                                                        name="conditionalType"
                                                                        value="weight"
                                                                        checked={values.conditionalType === "weight"}
                                                                        onChange={(e) => {
                                                                            handleChange(e);
                                                                            setFieldValue('minWeight', '')
                                                                            setFieldValue('maxWeight', '')
                                                                            setFieldValue('minPrice', '')
                                                                            setFieldValue('maxPrice', '')
                                                                        }}
                                                                    />
                                                                    Based on item weight
                                                                </label>
                                                                <label className="d-flex align-items-center gap-2">
                                                                    <input
                                                                        type="radio"
                                                                        name="conditionalType"
                                                                        value="price"
                                                                        checked={values.conditionalType === "price"}
                                                                        onChange={(e) => {
                                                                            handleChange(e);
                                                                            setFieldValue('minWeight', '')
                                                                            setFieldValue('maxWeight', '')
                                                                            setFieldValue('minPrice', '')
                                                                            setFieldValue('maxPrice', '')
                                                                        }}
                                                                    />
                                                                    Based on order price

                                                                </label>
                                                                {touched.conditionalType && errors.conditionalType && (
                                                                    <div className="text-red-500 text-sm">
                                                                        {errors.conditionalType}
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* Min & Max Weight */}
                                                            {values.conditionalType === "weight" && (
                                                                <div className="row">
                                                                    <div className="col-md-6 mb-3">
                                                                        <label>Minimum weight (kg)</label>
                                                                        <input
                                                                            type="number"
                                                                            name="minWeight"
                                                                            value={values.minWeight}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            className="form-control"
                                                                        />
                                                                        {touched.minWeight && errors.minWeight && (
                                                                            <div className="text-red-500 text-sm">
                                                                                {errors.minWeight}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <label>Maximum weight (kg)</label>
                                                                        <input
                                                                            type="number"
                                                                            name="maxWeight"
                                                                            value={values.maxWeight}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            className="form-control"
                                                                        />
                                                                        {touched.maxWeight && errors.maxWeight && (
                                                                            <div className="text-red-500 text-sm">
                                                                                {errors.maxWeight}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Min & Max Price */}
                                                            {values.conditionalType === "price" && (
                                                                <div className="row">
                                                                    <div className="col-md-6 mb-3">
                                                                        <label>Minimum price (£)</label>
                                                                        <input
                                                                            type="number"
                                                                            name="minPrice"
                                                                            value={values.minPrice}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            className="form-control"
                                                                        />
                                                                        {touched.minPrice && errors.minPrice && (
                                                                            <div className="text-red-500 text-sm">
                                                                                {errors.minPrice}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <label>Maximum price (£)</label>
                                                                        <input
                                                                            type="number"
                                                                            name="maxPrice"
                                                                            value={values.maxPrice}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            className="form-control"
                                                                        />
                                                                        {touched.maxPrice && errors.maxPrice && (
                                                                            <div className="text-red-500 text-sm">
                                                                                {errors.maxPrice}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}

                                                    {/* Preview */}
                                                    <div className=" preview-box">
                                                        <p>
                                                            <strong>Checkout preview</strong>
                                                        </p>
                                                        <div className="preview-box-inner border rounded bg-gray-100">
                                                            <div>
                                                                <div className="check-icon">
                                                                    <img src="/images/radio-icon.png" alt="" />
                                                                </div>
                                                                <div>{parse(values.shippingRateLabel)}</div>
                                                                {values.conditionalType === "price" ? `Price Range - (£${values.minPrice} - £${values.maxPrice})` : null}
                                                                {values.conditionalType === "weight" ? `Weight Range - (${values.minWeight}kg - ${values.maxWeight}kg)` : null}
                                                            </div>
                                                            <div className="price-tag">{values.price > 0 ? `£ ${values.price}` : 'Free'}</div>
                                                        </div>

                                                    </div>

                                                    {/* Submit */}
                                                    <div className="mt-3">
                                                        <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                                            {isSubmitting ? 'Please wait..' : 'Add Now'}
                                                        </button>
                                                    </div>
                                                </form>
                                            )}
                                        </Formik>
                                    </ThemeModal>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ShippingZoneRates;
